module.exports = __webpack_public_path__ + "img/why-need-loan-image_mobile.2c3c07ff.png";